import React, { ReactElement } from 'react';
import styled from 'styled-components/macro';
import Breakpoints from 'themes/constants/breakpoints';

// Styles
const Wrap = styled.h2<{ withMargin?: boolean, withoutMargin?: boolean }>`
  line-height: 1;
  font-weight: 500;
  text-align: start;
  font-size: 34px;
  color: ${({ theme }) => theme.palette.greyMiddle};
  margin: ${({ withMargin, withoutMargin }) => (withoutMargin ? '0' : withMargin ? '0 0 23px' : '23px 0 0')};
  padding: 0;
  text-transform: uppercase;
  letter-spacing: 2px;
  @media only screen and (${Breakpoints.MOBILE_M}) {
    font-size: 40px;
  }
  @media only screen and (${Breakpoints.TABLET}) {
    font-size: 60px;
  }
  @media only screen and (${Breakpoints.LAPTOP}) {
    margin: ${({ withMargin, withoutMargin }) => (withoutMargin ? '0' : withMargin ? '0 0 23px' : '23px 0 0')};
  }
`;

// Interfaces
type IChild = string | ReactElement | null;
interface ITitleMain {
  className?: string
  withMargin?: boolean
  withoutMargin?: boolean
  children: IChild | IChild[];
  onClick?: () => void
}

// Component
const TitleMain = (props: ITitleMain) => {
  const {
    className,
    withMargin = true,
    withoutMargin = false,
    children,
    onClick,
  } = props;

  return (
    <Wrap
      onClick={onClick}
      className={className}
      withMargin={withMargin}
      withoutMargin={withoutMargin}
    >
      {children}
    </Wrap>
  );
};

TitleMain.defaultProps = {
  className: '',
  withMargin: true,
  withoutMargin: false,
  onClick: () => {},
};

export default TitleMain;
